export const dropdowns = () => {
	const selects = document.querySelectorAll('select.contact-form__select, select.custom-select__native, select');
	
	if (!selects.length) {
		return;
	}

	const closeAllDropdowns = (exceptDropdown = null) => {
		document.querySelectorAll('.custom-select--active').forEach((dropdown) => {
			if (dropdown !== exceptDropdown) {
				dropdown.classList.remove('custom-select--active');

				const toggle = dropdown.querySelector('.custom-select__toggle');
				if (toggle) {
					toggle.setAttribute('aria-expanded', 'false');
				}
			}
		});
	};

	const updateDropdownValue = (select, dropdown) => {
		const valueLabel = dropdown.querySelector('.custom-select__value');
		const options = dropdown.querySelectorAll('.custom-select__option');
		const selectedOption = select.options[select.selectedIndex];

		if (valueLabel) {
			valueLabel.textContent = selectedOption?.textContent?.trim() || select.getAttribute('data-placeholder') || 'Wybierz';
		}

		options.forEach((optionButton) => {
			const isSelected = optionButton.dataset.value === select.value;
			optionButton.classList.toggle('custom-select__option--selected', isSelected);
			optionButton.setAttribute('aria-selected', String(isSelected));
		});
	};

	selects.forEach((select) => {
		if (select.dataset.dropdownReady === 'true') {
			return;
		}

		select.dataset.dropdownReady = 'true';
		select.classList.add('custom-select__native');

		const existingParent = select.parentElement;
		if (!existingParent) {
			return;
		}

		const dropdown = document.createElement('div');
		dropdown.className = 'custom-select';

		const toggleButton = document.createElement('button');
		toggleButton.type = 'button';
		toggleButton.className = 'custom-select__toggle';
		toggleButton.setAttribute('aria-haspopup', 'listbox');
		toggleButton.setAttribute('aria-expanded', 'false');

		const valueSpan = document.createElement('span');
		valueSpan.className = 'custom-select__value';

		const caretSpan = document.createElement('span');
		caretSpan.className = 'custom-select__caret';

		toggleButton.append(valueSpan, caretSpan);

		const optionsList = document.createElement('div');
		optionsList.className = 'custom-select__options';
		optionsList.setAttribute('role', 'listbox');

		Array.from(select.options).forEach((option, index) => {
			const optionButton = document.createElement('button');
			optionButton.type = 'button';
			optionButton.className = 'custom-select__option';
			optionButton.textContent = option.textContent;
			optionButton.dataset.value = option.value;
			optionButton.setAttribute('role', 'option');
			optionButton.setAttribute('aria-selected', String(option.selected));

			if (option.disabled || option.value === '') {
				optionButton.dataset.placeholder = 'true';
			}

			optionButton.addEventListener('click', () => {
				if (option.disabled) {
					return;
				}

				select.value = option.value;
				select.dispatchEvent(new Event('change', { bubbles: true }));
				updateDropdownValue(select, dropdown);
				dropdown.classList.remove('custom-select--active');
				toggleButton.setAttribute('aria-expanded', 'false');
			});

			optionsList.appendChild(optionButton);
		});

		dropdown.append(toggleButton, optionsList);
		existingParent.insertBefore(dropdown, select);
		dropdown.insertBefore(select, toggleButton);

		toggleButton.addEventListener('click', (event) => {
			event.preventDefault();
			event.stopPropagation();

			const isActive = dropdown.classList.contains('custom-select--active');

			closeAllDropdowns();

			if (!isActive) {
				dropdown.classList.add('custom-select--active');
				toggleButton.setAttribute('aria-expanded', 'true');
			}
		});

		select.addEventListener('change', () => {
			updateDropdownValue(select, dropdown);
		});

		updateDropdownValue(select, dropdown);
	});

	document.addEventListener('click', () => {
		closeAllDropdowns();
	});

	document.addEventListener('keydown', (event) => {
		if (event.key === 'Escape') {
			closeAllDropdowns();
		}
	});
}